<template>
  <EditCom
    title="推送标注"
    :target="target"
    :buttonList="buttonList"
    :inputList="inputList"
    :rules="rules"
    @closeFun="close"
  ></EditCom>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive,
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import EditCom from '@/components/EditCom';

import { queryOrdinaryUserList } from '@/api/System/UserManager';
import { configMarkPush, } from '@/api/UserDrawApi';

// props
const props = defineProps({
  target: { type: Object },
});
// emit
const emit = defineEmits([
  'close',
]);

const close = ()=>{
  emit('close');
}

const target = ref({
  ...props.target,
  allPushList: [
    { label: '是', value: 1 },
    { label: '否', value: 0 },
  ]
})

const pushChangeFn = (item, prop, value)=>{
  // console.log(item, prop, value);
  if(value == 1){
    rules['userIdList'] = undefined;
  }else{
    rules['userIdList'] = [
      { required: true, message: '请选择角色', trigger: 'blur' },
    ];
  }
}

const submitFn = (item, button, loadFn, fn)=>{
  configMarkPush({
    bizId: item['bizId'],
    favoriteId: item['id'],
    userIdList: item['userIdList'],
    allPush: item['allPush'],
  }).then(res=>{
    if(res.data.code == 1004){
      message(res.data.msg, 1);
      close();
    }
    loadFn && loadFn();
  }).catch(err=>{
    loadFn && loadFn();
    console.log(err);
  });
}
const submit = (form, item, button, loadFn, fn)=>{
  // console.log(form, item, button, loadFn, fn);
  form.value.validate((valid)=>{
    // console.log(valid);
    if(valid){
      submitFn(item, button, loadFn, fn);
    }else{
      loadFn && loadFn();
    }
  });
};

const buttonList = ref([
  { name: '取消', fun: close, type: 'danger', },
  { name: '确定', fun: submit, type: 'primary', },
]);
const inputList = ref([
  { name: '推送角色', prop: 'userIdList', type: 'select',
    select: {
      list: 'userList',
      label: 'userName',
      value: 'userId',
      filterable: true,
      multiple: true,
    }
  },
  {
    name: '全部推送', prop: 'allPush',  type: 'select',
    select: {
      list: 'allPushList',
      label: 'label',
      value: 'value',
      changeFun: pushChangeFn,
    },
  }
]);

const rules = reactive({
  userIdList: [
    { required: true, message: '请选择角色', trigger: 'blur' },
  ],
  allPush: [
    { required: true, message: '请选择是否全部推送', trigger: 'blur' },
  ],
});

const queryOrdinaryUserListFn = ()=>{
  queryOrdinaryUserList({}).then(res=>{
    if(res.data.code == 1004){
      target.value['userList'] = res['data']['data'];
    }
  }).catch(err=>{
    console.log(err);
  });
}

// 组件挂载前
onBeforeMount(()=>{
  queryOrdinaryUserListFn();
});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>